/**
 * APM 监控工具类
 *
 * 2026-09-01 清理：PerformanceMonitor / UserBehaviorMonitor / BusinessMonitor / UserManager
 * 四个类与 ErrorMonitor 的 trackAPIError/trackResourceError 方法已删除——全项目排查后
 * 确认它们唯一的调用方是同样零调用的 src/hooks/useAPM.ts（已一并删除），从未真正上报过
 * 一条数据。仅保留 ErrorMonitor.trackError，它是 SilentErrorBoundary 的错误上报出口。
 */

import { reportError, reportCustomLog } from '@/config/apm';

// 错误监控类
export class ErrorMonitor {
  /**
   * 记录业务错误
   * @param error 错误对象或错误信息
   * @param context 错误上下文
   * @param level 错误级别
   */
  static trackError(
    error: Error | string,
    context?: Record<string, string>,
    level: 'error' | 'warn' = 'error',
    react?: { version: string; componentStack: string }
  ): void {
    if (error instanceof Error) {
      reportError(error, context, react);
    } else {
      reportCustomLog(error, level, context);
    }
  }
}

export default { Error: ErrorMonitor };
